import FormConfig from "../formDepartmentConfig.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        zoneCode: null, // 所属区管单位
        departmentName: null, // 部门名称
        departmentCode: null, // 部门代码
        tradingCenter: null, // 缴费交易中心
        abolishFlag: null, // 是否废止
        isPay: null, // 是否缴费
        phoneNumber: null, // 电话
        fax: null, // 传真号码
        postalCode: null, // 邮政编码
        address: null, // 地址
        isAudit: null, // 是否报送监管
        areaCode: null, // 行政区划
        purchaserIds: new Array(), // 交易目录
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        zoneCode: null, // 所属区管单位
        departmentName: null, // 部门名称
        departmentCode: null, // 部门代码
        tradingCenter: null, // 缴费交易中心
        abolishFlag: null, // 是否废止
        isPay: null, // 是否缴费
        phoneNumber: null, // 电话
        fax: null, // 传真号码
        postalCode: null, // 邮政编码
        address: null, // 地址
        isAudit: null, // 是否报送监管
        areaCode: null, // 行政区划
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type, // 页面类型
      id: this.$route.query.id, // 联合体页面标志
      flag: this.$route.query.flag, // 标志
    };
  },
  // 注册组件
  components: {
  },
  // 接收父组件传递的数据
  props: {
  
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/zoneDepartment/detail", {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.data;
          this.form.purchaserIds = [];
          // 设置交目录
          // 遍历
          data.purchaserIds.map(e=>{
            // 回显
            this.form.purchaserIds.push([e.pid, e.purchaserId]);
          })
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 回显字段
      this.form[i] = e;
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 交易目录集合
          let purchaserIds = [];
          // 遍历勾选
          for(const index in this.form.purchaserIds){
            // 赋值主键集合
            purchaserIds[index] = this.form.purchaserIds[index][1];
          }
          // 请求
          fun_PostAction("/zoneDepartment/saveOrUpdate", {
            zoneDepartment: JSON.stringify(this.form),
            purchaserIdList: JSON.stringify(purchaserIds),
            controllerFlg: this.controllerFlg
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
